import $ from "jquery";

const login = () => {
  const init = () => {
    WrongCode();
  };

  // if (chapter === 0) return;

  const form = $(".mi-Form--Login");
  const inputEmail = $(".mi-Form__Input--email");
  const messageEmail = $(".js-ErrorMessageEmail");
  const inputCode = $(".mi-Form__Input--code");
  const messageCode = $(".js-ErrorMessageCodeAccess");

  messageEmail.add(messageCode).hide();

  // const showError = (el) => {
  //   if(el === '')
  //   popupStar.hide();
  //   $(`#${target}`).show();
  // };

  const WrongCode = () => {
    form.on("submit", function (e) {
      if (inputEmail.val() === "" || inputCode.val() === "") {
        e.preventDefault();
        if (inputEmail.val() !== "") {
          inputCode.addClass("mi-Form__Input--error");
          messageCode.html("Veld kan niet leeg zijn.");
          messageCode.show();
        } else if (inputCode.val() !== "") {
          inputEmail.addClass("mi-Form__Input--error");
          messageEmail.html("Veld kan niet leeg zijn.");
          messageEmail.show();
        } else {
          inputEmail.addClass("mi-Form__Input--error");
          messageEmail.html("Veld kan niet leeg zijn.");
          messageEmail.show();
          inputCode.addClass("mi-Form__Input--error");
          messageCode.html("Veld kan niet leeg zijn.");
          messageCode.show();
        }
      } else {
        inputEmail.removeClass("mi-Form__Input--error");
        inputCode.removeClass("mi-Form__Input--error");
        messageEmail.hide();
        messageCode.hide();
      }
    });
  };

  init();
};

login();
